// extracted by mini-css-extract-plugin
export default {"page":"AppRoutes_page__VJjO1","page_container":"AppRoutes_page_container__YGMbX","page_content":"AppRoutes_page_content__Zvd5m","left_aligned_bg":"AppRoutes_left_aligned_bg__zR2qu"};